import { render, staticRenderFns } from "./AllCoursesCategories.vue?vue&type=template&id=5e39123a&scoped=true&"
import script from "./AllCoursesCategories.vue?vue&type=script&lang=js&"
export * from "./AllCoursesCategories.vue?vue&type=script&lang=js&"
import style0 from "./AllCoursesCategories.vue?vue&type=style&index=0&id=5e39123a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e39123a",
  null
  
)

export default component.exports